/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';
import colors from '../../assets/colors';

export const Content = styled.div`
  .tabs {
    display: flex;
    flex-direction: row;
  }

  .left {
    height: ${props => (props.roleType === 'owner' ? '94px' : '49px')};
    padding: 15px;
    margin-right: 30px;
    background-color: #E9E9E9;
    border-radius: 6px;
    box-shadow: inset 0 0 5px 0 rgba(0, 0, 0, 0.2);
    
    ul {
      padding: 3px 15px;
      background-color: #FFFFFF;
      border-radius: 6px;
      margin: 0;
      box-shadow: 3px 3px 0px -1px rgba(0,0,0,0.04);
    }

    li {
      list-style: none;
      color: #999999;
      font-size: 0.9rem;
      letter-spacing: -0.2px;
      font-weight: 600;
      border-bottom: 1px solid ${colors.lighter};
      cursor: pointer;
      -webkit-tap-highlight-color: rgba(0,0,0,0);

      .fa {
        float: right;
        font-size: 1.0rem;
        padding: 13px 0;
      }
    
      .fa-exclamation-circle { color: ${colors.red} }

      span {
        padding: 12px 0;
        display: inline-block;
        width: 100%;

        :hover {
          color: ${colors.primary};
        }
      }

      span.required { width: 90%; }
    }

    li:last-child {
      border-bottom: none;
    }

    .react-tabs__tab--selected span {
      color: ${colors.primary};
    }
  }

  .right {
    flex: 1;
  }

  @media screen and (min-width: 1090px) {
    .left {
      width: 250px;
    }
  }

  @media screen and (max-width: 1089px) {
    .tabs {
      flex-direction: column;
    }

    .left {
      flex: 1;
      margin-right: 0;
      margin-bottom: 30px;
    }
  }
`;
